var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTrafficTransportation01 = function SvgAlertTrafficTransportation01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert_traffic_transportation-01_svg2__a",
    x1: 18.21,
    x2: 191.85,
    y1: 203.73,
    y2: 47.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_traffic_transportation-01_svg2__a",
    id: "alert_traffic_transportation-01_svg2__b",
    x1: 48.13,
    x2: 221.78,
    y1: 236.89,
    y2: 80.19
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_traffic_transportation-01_svg2__a",
    id: "alert_traffic_transportation-01_svg2__c",
    x1: 29.85,
    x2: 203.5,
    y1: 216.64,
    y2: 59.93
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_traffic_transportation-01_svg2__a",
    id: "alert_traffic_transportation-01_svg2__d",
    x1: 36.48,
    x2: 210.13,
    y1: 223.99,
    y2: 67.28
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_traffic_transportation-01_svg2__a",
    id: "alert_traffic_transportation-01_svg2__e",
    x1: -7.88,
    x2: 165.77,
    y1: 174.83,
    y2: 18.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_traffic_transportation-01_svg2__a",
    id: "alert_traffic_transportation-01_svg2__f",
    x1: 27.01,
    x2: 200.66,
    y1: 213.49,
    y2: 56.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_traffic_transportation-01_svg2__a",
    id: "alert_traffic_transportation-01_svg2__g",
    x1: 60.95,
    x2: 234.59,
    y1: 251.1,
    y2: 94.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_traffic_transportation-01_svg2__a",
    id: "alert_traffic_transportation-01_svg2__h",
    x1: -15.21,
    x2: 158.44,
    y1: 166.71,
    y2: 10
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_traffic_transportation-01_svg2__a",
    id: "alert_traffic_transportation-01_svg2__i",
    x1: -13.25,
    x2: 160.39,
    y1: 168.87,
    y2: 12.17
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_traffic_transportation-01_svg2__a",
    id: "alert_traffic_transportation-01_svg2__j",
    x1: -26.52,
    x2: 147.13,
    y1: 154.17,
    y2: -2.53
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M66.67 150c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10m0 13.33c-1.84 0-3.33-1.49-3.33-3.33s1.49-3.33 3.33-3.33S70 158.16 70 160s-1.49 3.33-3.33 3.33",
    style: {
      fill: "url(#alert_traffic_transportation-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.33 150c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10m0 13.33c-1.84 0-3.33-1.49-3.33-3.33s1.49-3.33 3.33-3.33 3.33 1.49 3.33 3.33-1.49 3.33-3.33 3.33",
    style: {
      fill: "url(#alert_traffic_transportation-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33 150H86.66c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h26.67c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#alert_traffic_transportation-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33 163.33H86.66c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h26.67c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#alert_traffic_transportation-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.33 136.67c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10m0 13.33c-1.84 0-3.33-1.49-3.33-3.33s1.49-3.33 3.33-3.33 3.33 1.49 3.33 3.33-1.49 3.33-3.33 3.33",
    style: {
      fill: "url(#alert_traffic_transportation-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.82 123.58-7.79-23.36a10.055 10.055 0 0 0-9.42-6.86h-.11l-50.44-.07c-4.27.05-8.04 2.79-9.39 6.84l-2.17 6.52h-13l-2.17-6.52a10.03 10.03 0 0 0-9.44-6.84l-50.36.07h-.11a10.06 10.06 0 0 0-9.46 6.84l-7.79 23.37C6.05 124.8.02 131.78 0 140v23.33c0 3.68 2.98 6.67 6.67 6.67v10c0 3.68 2.98 6.67 6.67 6.67h13.33c3.68 0 6.67-2.98 6.67-6.67v-10h10v6.67c0 3.68 2.98 6.67 6.67 6.67v10c0 3.68 2.98 6.67 6.67 6.67h13.33c3.68 0 6.67-2.98 6.67-6.67v-10h46.67v10c0 3.68 2.98 6.67 6.67 6.67h13.33c3.68 0 6.67-2.98 6.67-6.67v-10c3.68 0 6.67-2.98 6.67-6.67V170h10v10c0 3.68 2.98 6.67 6.67 6.67h13.33c3.68 0 6.67-2.98 6.67-6.67v-10c3.68 0 6.67-2.98 6.67-6.67V140c-.02-8.22-6.05-15.2-14.18-16.42ZM115 102.25a3.34 3.34 0 0 1 3.1-2.29l50.44.07h.03c1.43.01 2.69.93 3.13 2.29l7 21h-40.75l-3.29-9.84a10.01 10.01 0 0 0-9.45-6.84h-11.69zm10.2 11.06c1.43 0 2.69.93 3.14 2.28l7.03 21.08H64.62l7-21.03a3.33 3.33 0 0 1 3.18-2.28h.02l50.37-.05Zm-96.9-11a3.35 3.35 0 0 1 3.17-2.28h.04l50.35-.07c1.43.02 2.69.93 3.14 2.29l1.48 4.41H74.85a9.97 9.97 0 0 0-9.54 6.84l-3.27 9.83H21.29zM26.67 180H13.34v-10h13.33zm16.66-36.67h3.42a16.36 16.36 0 0 0-3.08 6.67h-.34c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33v6.67H6.67V140c0-5.52 4.48-10 10-10h43.15l-2.22 6.67H43.34c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33Zm26.67 50H56.67v-10H70zm73.33 0H130v-10h13.33zm6.67-16.66H50v-23.33c0-5.52 4.48-10 10-10h80c5.52 0 10 4.48 10 10zm36.67 3.33h-13.33v-10h13.33zm6.66-16.67h-36.67v-6.67c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-.33c-.51-2.43-1.57-4.7-3.08-6.67h3.42c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-14.26l-2.22-6.67h43.15c5.52 0 10 4.48 10 10v23.33Z",
    style: {
      fill: "url(#alert_traffic_transportation-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.67 136.67c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10m0 13.33c-1.84 0-3.33-1.49-3.33-3.33s1.49-3.33 3.33-3.33 3.33 1.49 3.33 3.33-1.49 3.33-3.33 3.33",
    style: {
      fill: "url(#alert_traffic_transportation-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.02 86.67h85.96c3.8.02 7.3-2.08 9.07-5.44a10.58 10.58 0 0 0-.45-10.83L108.62 4.69C106.73 1.77 103.48 0 100 0s-6.73 1.77-8.62 4.69L48.4 70.4c-2.13 3.25-2.3 7.41-.45 10.83 1.77 3.36 5.27 5.46 9.07 5.44m-3.04-12.62L96.96 8.33a3.604 3.604 0 0 1 6.08 0l42.98 65.72c.8 1.2.86 2.74.16 4a3.58 3.58 0 0 1-3.2 1.94H57.02c-1.35 0-2.58-.75-3.2-1.94-.7-1.26-.63-2.8.16-4",
    style: {
      fill: "url(#alert_traffic_transportation-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 70c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33-3.33 1.49-3.33 3.33S98.16 70 100 70",
    style: {
      fill: "url(#alert_traffic_transportation-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 56.67c1.84 0 3.33-1.49 3.33-3.33V26.67c0-1.84-1.49-3.33-3.33-3.33s-3.33 1.49-3.33 3.33v26.67c0 1.84 1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#alert_traffic_transportation-01_svg2__j)"
    }
  }));
};
export default SvgAlertTrafficTransportation01;